import def from '@app/locales/en/translation.json';
import api from '@app/locales/en/ApiDescriptions.json';

type Dictionary = string | DictionaryObject;
type DictionaryObject = { [K: string]: Dictionary };

export type TranslationsTypes = keyof typeof translations;
export type Translation = (val: TranslationsTypes) => string;

export interface TypedTFunction<D extends Dictionary> {
    <K extends keyof D>(args: K): D[K];
    <K extends keyof D, K1 extends keyof D[K]>(...args: [K, K1]): D[K][K1];
}

export type CountedTranslation = (count: number) => TranslationsTypes;

export enum TranslationNamespace {
    default = 'translations',
    apiDescription = 'apiDesc'
}

const helper = {
    '': ''
};

export const translations = Object.assign(def, api, helper);
